import { LongRunningAction } from "@shared/decorators/long-running-action.decorator";
import { NgxsActionName } from "@shared/constants";
import { NgxsCallBacks } from "@shared/stores/store.callbacks";
import { KpiITToolUsage } from "@shared/classes/kpi-it-tool-usage";
import { KpiEconomy } from "@shared/classes/kpi-economy";
import { KpiSafety } from "@shared/classes/kpi-safety";
import { CommonPageFilterSetting, CommonSearchCriteria, CreateCommonPageFilterSetting } from "@shared/models/common-data.model";
import { Achievement } from "@shared/classes/achievement";
import { DataImportExcelData } from "@shared/classes/data-import-validate-request";
import { DrivingBehavior } from "@shared/classes/driving-behavior";

export class SetPageViewInitialized {
  static readonly type = "[CommonData] Set Page View Initialized";
  constructor(public functionName: string) {}
}

export class SetSearchCriteriaWithLastModifyData {
  static readonly type = "[CommonData] Set Search Criteria With Last Modify Data";
  constructor(public functionName: string) {}
}

export class SetDefaultSearchCriteria {
  static readonly type = "[CommonData] Set Default Search Criteria";
  constructor(public functionName: string, public searchCriteria: CommonSearchCriteria[]) {}
}

@LongRunningAction(NgxsActionName.UPLOAD_ATTACHMENT)
export class UploadAttachment {
  static readonly type = "[AppData] Upload Attachment";
  constructor(public uploadUrl: string, public uploadFile: File) {}
}

@LongRunningAction(NgxsActionName.GET_DRIVER_DATA, NgxsCallBacks.GetDriverData)
export class GetDriverData {
  static readonly type = "[AppData] Get Driver Data";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_DRIVER_DATA)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_DRIVER_DATA)
export class UpdateDriverData {
  static readonly type = "[AppData] Update Driver Data";
  constructor() {}
}

@LongRunningAction(NgxsActionName.GET_TERMINALS_WITHOUT_SUBREGION)
export class GetTerminalsWithoutSubregion {
  static readonly type = "[AppData] Get Terminals Without Subregion";
  constructor() {}
}

@LongRunningAction(NgxsActionName.GET_ORG_UNIT, NgxsCallBacks.GetOrgUnit)
export class GetOrgUnit {
  static readonly type = "[AppData] Get Org Unit";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_ORG_UNIT)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_ORG_UNIT)
export class UpdateOrgUnit {
  static readonly type = "[AppData] Update Org Unit";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DELETE_ORG_UNIT)
export class DeleteOrgUnit {
  static readonly type = "[AppData] Delete Org Unit";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_USER_PROFILE, NgxsCallBacks.GetUserProfileData)
export class GetUserProfile {
  static readonly type = "[AppData] Get User Profile";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_USER_PROFILE)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_USER_PROFILE)
export class UpdateUserProfile {
  static readonly type = "[AppData] Update User Profile";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DELETE_USER_PROFILE)
export class DeleteUserProfile {
  static readonly type = "[AppData] Delete User Profile";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_IT_TOOL_USAGE, NgxsCallBacks.GetKpiITToolUsage)
export class GetKpiITToolUsage {
  static readonly type = "[AppData] Get KPI It Tool Usage";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_KPI_IT_TOOL_USAGE)) {}
}

@LongRunningAction(NgxsActionName.DELETE_KPI_IT_TOOL_USAGE)
export class DeleteKpiITToolUsage {
  static readonly type = "[AppData] Delete KPI IT Tool Usage";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_IT_TOOL_USAGE)
export class UpdateKpiITToolUsage {
  static readonly type = "[AppData] Update KPI IT Tool Usage";
  constructor(public data: KpiITToolUsage) {}
}

@LongRunningAction(NgxsActionName.IMPORT_KPI_IT_TOOL_USAGE_DATA)
export class ImportKpiITToolUsageData {
  static readonly type = "[AppData] Import KPI IT Tool Usage Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.IMPORT_EVCR_COMPLIANCE_DATA)
export class ImportEVCRComplianceData {
  static readonly type = "[AppData] Import EVCR Compliance Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.IMPORT_APT_COMPLIANCE_DATA)
export class ImportAPTComplianceData {
  static readonly type = "[AppData] Import APT Compliance Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.IMPORT_SAFTY_MEETING_COMPLIANCE_DATA)
export class ImportSaftyMeetingComplianceData {
  static readonly type = "[AppData] Import Safty Meeting Compliance Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_SAFETY, NgxsCallBacks.GetKpiSafety)
export class GetKpiSafety {
  static readonly type = "[AppData] Get KPI Safety";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_KPI_SAFETY)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_SAFETY)
export class UpdateKpiSafety {
  static readonly type = "[AppData] Update KPI Safety";
  constructor(public data: KpiSafety) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_DRIVING_BEHAVIOR, NgxsCallBacks.GetKpiDrivingBehavior)
export class GetKpiDrivingBehavior {
  static readonly type = "[AppData] Get KPI Driving Behavior";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_KPI_DRIVING_BEHAVIOR)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_DRIVING_BEHAVIOR)
export class UpdateKpiDrivingBehavior {
  static readonly type = "[AppData] Update Kpi Driving Behavior";
  constructor(public data: DrivingBehavior) {}
}

@LongRunningAction(NgxsActionName.DELETE_KPI_DRIVING_BEHAVIOR)
export class DeleteKpiDrivingBehavior {
  static readonly type = "[AppData] Delete KPI Driving Behavior";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.IMPORT_KPI_DRIVING_BEHAVIOR_DATA)
export class ImportKpiDrivingBehaviorData {
  static readonly type = "[AppData] Import KPI Driving Behavior Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_ECONOMY, NgxsCallBacks.GetKpiEconomy)
export class GetKpiEconomy {
  static readonly type = "[AppData] Get KPI Economy";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_KPI_ECONOMY)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_ECONOMY)
export class UpdateKpiEconomy {
  static readonly type = "[AppData] Update KPI Economy";
  constructor(public data: KpiEconomy) {}
}

@LongRunningAction(NgxsActionName.DELETE_KPI_ECONOMY)
export class DeleteKpiEconomy {
  static readonly type = "[AppData] Delete KPI Economy";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.IMPORT_KPI_ECONOMY_DATA)
export class ImportKpiEconomyData {
  static readonly type = "[AppData] Import KPI Economy Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_OTHERS, NgxsCallBacks.GetKpiOthers)
export class GetKpiOthers {
  static readonly type = "[AppData] Get KPI Others";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_KPI_OTHERS)) {}
}

@LongRunningAction(NgxsActionName.GET_KPI_OTHERS_ATTACHMENT)
export class GetKpiOthersAttachment {
  static readonly type = "[AppData] Get KPI Others Attachment";
  constructor(public id: number) {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_OTHERS)
export class UpdateKpiOthers {
  static readonly type = "[AppData] Update KPI Others";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DELETE_KPI_OTHERS)
export class DeleteKpiOthers {
  static readonly type = "[AppData] Delete KPI Others";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_COACHING, NgxsCallBacks.GetCoaching)
export class GetCoaching {
  static readonly type = "[AppData] Get Coaching";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_COACHING)) {}
}

@LongRunningAction(NgxsActionName.GET_COACHING_ATTACHMENT)
export class GetCoachingAttachment {
  static readonly type = "[AppData] Get Coaching Attachment";
  constructor(public id: number) {}
}

@LongRunningAction(NgxsActionName.UPDATE_COACHING)
export class UpdateCoaching {
  static readonly type = "[AppData] Update Coaching";
  constructor() {}
}

@LongRunningAction(NgxsActionName.UPLOAD_COACHING_ATTACHMENT)
export class UploadCoachingAttachment {
  static readonly type = "[AppData] Upload Coaching Attachment";
  constructor(public uploadUrl: string, public uploadFile: File) {}
}

@LongRunningAction(NgxsActionName.GET_ACHIEVEMENT, NgxsCallBacks.GetAchievement)
export class GetAchievement {
  static readonly type = "[AppData] Get Achievement";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_ACHIEVEMENT)) {}
}

@LongRunningAction(NgxsActionName.IMPORT_ACHIEVEMENT_DATA)
export class ImportAchievementData {
  static readonly type = "[AppData] Import Achievement Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.UPDATE_ACHIEVEMENT)
export class UpdateAchievement {
  static readonly type = "[AppData] Update Achievement";
  constructor(public data: Achievement) {}
}

@LongRunningAction(NgxsActionName.GET_AWARD, NgxsCallBacks.GetAward)
export class GetAward {
  static readonly type = "[AppData] Get Award";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_AWARD)) {}
}

@LongRunningAction(NgxsActionName.IMPORT_AWARD_DATA)
export class ImportAwardData {
  static readonly type = "[AppData] Import Award Data";
  constructor(public importData: any[]) {}
}

@LongRunningAction(NgxsActionName.UPDATE_AWARD)
export class UpdateAward {
  static readonly type = "[AppData] Update Awared";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DELETE_AWARD)
export class DeleteAward {
  static readonly type = "[AppData] Delete Award";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_EXTERNAL_REPORT)
export class GetExternalReport {
  static readonly type = "[AppData] Get External Report";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_EXTERNAL_REPORT)) {}
}

@LongRunningAction(NgxsActionName.GET_REPORT_LINK)
export class GetReportLink {
  static readonly type = "[AppData] Get Report Link";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_REPORT_LINK)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_REPORT_LINK)
export class UpdateReportLink {
  static readonly type = "[AppData] Update Report Link";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DELETE_REPORT_LINK)
export class DeleteReportLink {
  static readonly type = "[AppData] Delete Report Link";
  constructor(public deleteIdList: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_TEAM_MESSAGE)
export class GetTeamMessage {
  static readonly type = "[AppData] Get Team Message";
  constructor(public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_TEAM_MESSAGE)) {}
}

@LongRunningAction(NgxsActionName.UPDATE_TEAM_MESSAGE)
export class UpdateTeamMessage {
  static readonly type = "[AppData] Update Team Message";
  constructor() {}
}

@LongRunningAction(NgxsActionName.GET_DRIVER_BY_TERMINAL)
export class GetDriverByTerminal {
  static readonly type = "[AppData] Get Driver By Terminal";
  constructor(public terminal_Ids: number[]) {}
}

@LongRunningAction(NgxsActionName.GET_TEAM_MESSAGE_READ, NgxsCallBacks.GetTeamMessageRead)
export class GetTeamMessageRead {
  static readonly type = "[AppData] Get Team Message Read";
  constructor(public teamMessage_id: number, public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_TEAM_MESSAGE_READ)) {}
}

@LongRunningAction(NgxsActionName.GET_TEAM_MESSAGE_READ_FOR_EXPORT, NgxsCallBacks.GetTeamMessageReadForExport)
export class GetTeamMessageReadForExport {
  static readonly type = "[AppData] Get Team Message Read For Export";
  constructor(public teamMessage_id: number, public setting: CommonPageFilterSetting = CreateCommonPageFilterSetting(NgxsActionName.GET_TEAM_MESSAGE_READ_FOR_EXPORT)) {}
}

export class SetKpiConfigurationSearchValueOfCountry {
  static readonly type = "[AppData] Set Kpi Configuration Search Value Of Country";
  constructor() {}
}

@LongRunningAction(NgxsActionName.GET_KPI_CONFIGURATION, NgxsCallBacks.GetKpiConfiguration)
export class GetKpiConfiguration {
  static readonly type = "[AppData] Get Kpi Configuration";
  constructor() {}
}

@LongRunningAction(NgxsActionName.UPDATE_KPI_CONFIGURATION)
export class UpdateKpiConfiguration {
  static readonly type = "[AppData] Update Kpi Configuration";
  constructor() {}
}

@LongRunningAction(NgxsActionName.COMMAND_INVOKE)
export class CommandInvoke {
  static readonly type = "[CommonData] Command Invoke";
  constructor() {}
}

@LongRunningAction(NgxsActionName.DATA_IMPORT_VALIDATE)
export class DataImportValidate {
  static readonly type = "[AppData] Data Import Validate";
  constructor(public excelData: DataImportExcelData) {}
}
